module.exports = __webpack_public_path__ + "img/aa2a9ee.jpg";